import styled from 'styled-components';
import { colors, toRgba } from '@/styles';

export const ModelSelectOption = styled.div`
  display: flex !important;
  padding: 0 !important;
  flex-direction: column;
  border-bottom: 1px solid ${toRgba(colors.primary.black, 0.5)};
  gap: 5px;
  & > * {
    padding: 0px 12px;
    &:first-child {
      padding-top: 5px;
    }
    &:last-child {
      padding-bottom: 5px;
    }
  }
  .option-provider {
    display: flex;
    align-items: center;
    gap: 10px;

    /* background-color: ${toRgba(colors.primary.black, 0.05)}; */
    /* border-top: 1px solid ${toRgba(colors.primary.black, 0.1)}; */
    /* padding: 5px; */
  }
`;
